module.exports = __webpack_public_path__ + "static/img/tutoriales sin texto utopie-2.ee2d1c93.jpg";